import React from "react";

const NeonRingLoader = () => {
  return (
    <div className="flex justify-center items-center min-h-[150px]">
      <div className="w-16 h-16 border-4 border-t-[#00F0FF] border-r-transparent border-b-[#FF007F] border-l-transparent rounded-full animate-spin" />
    </div>
  );
};

export default NeonRingLoader;
